// TODO - Type 'any' needs to be fixed.
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { StaticDatePicker } from "@mui/x-date-pickers/StaticDatePicker";
import React from "react";

import { useDatePickerLocale } from "../../utils/date-locale";

function DayDatePicker({ currentDate, handleCalendarClick }:any) {
	const [value, setValue] = React.useState(new Date(currentDate));
	const pickerLocale = useDatePickerLocale();

	const handleChange = (newValue:any) => {
		setValue(newValue);
		handleCalendarClick(new Date(newValue));
	};

	return (
		<Box
			sx={{
				".MuiCalendarPicker-root": {
					margin: 0,
				},
				".MuiButtonBase-root-MuiPickersDay-root.Mui-selected": {
					backgroundColor: "red",
				},
			}}
		>
			<LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={pickerLocale}>
				<StaticDatePicker
					displayStaticWrapperAs='desktop'
					openTo='day'
					value={value}
					onChange={(newValue) => handleChange(newValue)}
					renderInput={(params) => <TextField {...params} />}
				/>
			</LocalizationProvider>
		</Box>
	);
}

export default DayDatePicker;
